import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LabpartnerService } from '../services/labpartner.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  standalone: false,
})
export class LoaderComponent implements OnInit, OnDestroy {
  showLoader = false;
  private subscription = new Subscription();

  constructor(
    private labPartnerService: LabpartnerService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    // Subscribe to httpRequestCount$ and update showLoader asynchronously
    // to avoid ExpressionChangedAfterItHasBeenCheckedError
    // The setTimeout ensures the change happens in the next change detection cycle
    this.subscription.add(
      this.labPartnerService.httpRequestCount$.subscribe(count => {
        // Schedule the update in the next tick to avoid ExpressionChangedAfterItHasBeenCheckedError
        setTimeout(() => {
          this.showLoader = count > 0;
          this.cdr.markForCheck();
        }, 0);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
